import React, { useState } from 'react';
import './LogComponent.scss';
import Button, { ButtonTheme } from '../../atoms/button/button';
import FormCheckbox from '../../molecules/formCheckbox/formCheckbox';
const LogFilter = ({filters,onFilter}) => {
    const [filterText,setFilterText] =useState("");
    const [filterChecks,setFilterChecks] =useState([]);
    const [logCounters,setLogCounters] =useState({});
    const [myFilters,setMyFilters] =useState({});
    const [debounceTimeout, setDebounceTimeout] = useState(null);

    const handlerOnKeyDown=(e)=>{
          setFilterText(e.target.value);
          // setFiltered(true);
          let newFilters={...myFilters,"filterText":e.target.value};
          setMyFilters(newFilters);
        if (e.key === 'Enter') {
          onFilter(myFilters);
        }
    }

    const handlerOnchangeCheckFilter=(e,mode)=>{
        filterChecks[mode] = e.target.checked;
        setFilterChecks({...filterChecks});
        let newFilters={...myFilters,"filterChecks":{...filterChecks}};
        setMyFilters(newFilters);
        onFilter(newFilters);
    }
    const handlerOnChangeFilter=(e)=>{
        setFilterText(e.target.value);
        let newFilters={...myFilters,"filterText":e.target.value};
        // Clear previous timeout
        if (debounceTimeout) {
          clearTimeout(debounceTimeout);
        }
        // Set a new timeout
        const timeout = setTimeout(() => {
          onFilter(newFilters);
        }, 500); // Delay of 500ms
        setDebounceTimeout(timeout);
    }

    const onClear=()=>{
        setFilterChecks([]);
        setFilterText("");
        setMyFilters({});
        onFilter({});
    }

    const onSearch=()=>{
        //need to export the values from filter options
        onFilter(myFilters);
    }

    return(
      <div className="border-box">
        {filters && filters.length>0 && <div className="row">
            {filters.map((el,index)=>(
            <div key={index} className="col-sm-3">
              <FormCheckbox
                id={el.type.toLowerCase()}
                key={el.type.toLowerCase()+index}
                label={el.text+(logCounters[el.type.toLowerCase()]>0?" ("+logCounters[el.type.toLowerCase()]+")":"")}
                name={el.text}
                labelForm="true"
                onChange={(e)=>handlerOnchangeCheckFilter(e,el.type.toLowerCase())}
                checked={filterChecks[el.type.toLowerCase()]}
              />
            </div>))}
            </div>}
              <div className="row">
                {<div className="filter-text a" >
                  <label
                    className="col-form-label"
                    htmlFor="Filters"
                  >
                    Filter by text
                  </label>
                </div>}
                {<div className="col-sm-6">
                  <input
                    className="form-control "
                    id="search"
                    name="search"
                    onKeyDown={handlerOnKeyDown}
                    onChange={handlerOnChangeFilter}
                    placeholder="write something..."
                    type="text"
                    value={filterText}
                  />
                </div>}
                {(filters.length>0) &&<div className="col-sm-4 text-right">
                <Button
                      id={`search`}
                      type={'button'}
                      onClick={() => onClear()}
                      theme={ButtonTheme.PRIMARY}
                >
                      Clear
                </Button>
              </div>}
            </div>
      </div>
);
}
export default LogFilter;
